module.exports = __webpack_public_path__ + "res/Roboto-LightItalic-webfont.svg?f58c69f0d0eec2527aae157855259917";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-LightItalic-webfont.svg
// module id = 70
// module chunks = 0